import { FileTypes } from './../enums/file-types';
import { Attachment } from "./attachment";

export class ExperienceAttachment extends Attachment {
  url: string | null;
  experienceId: string;
  filePath: string;
}

export class PreviewAttachment extends ExperienceAttachment {
  attachmentUIPath: any;
  isYoutubeVideoLink: boolean;
  isAudioLink: boolean;
  fileType: FileTypes
}
